import { render, staticRenderFns } from "./ChangeEditor.Vue?vue&type=template&id=9a480ad4&scoped=true"
import script from "./ChangeEditor.Vue?vue&type=script&lang=js"
export * from "./ChangeEditor.Vue?vue&type=script&lang=js"
import style0 from "./ChangeEditor.Vue?vue&type=style&index=0&id=9a480ad4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a480ad4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangeEditor.Vue
// module id = 159
// module chunks = 0